import React, { useEffect, useState } from 'react';
import { Body, Micro, Title } from '@vds/typography';
import './CalendarViewCards.scss';
import { Icon } from '@vds/icons';
import { ButtonIcon } from '@vds/button-icons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ResourceTag from '../ResourceTag/resourceTag';
import { contentClick } from '../../../common/Analytics/GAWrapper';
import { getImageToBeRendered, getWithExpiry, navigateUsingLanguage } from '../../../utility/utils';
import { isMobile, isTablet, isDesktop } from 'react-device-detect';

const CalendarViewCardComponent = (props) => {
  const { t } = useTranslation();
  const { type, inPersonEventCxData, isInPersonEvent, data,sectionKey } = props ?? {}
  const modifiedType = type ? type : props?.data?.format === "Course" ? "courses" : props?.data?.format === "Event" ? "events" : props?.data?.format === "Learning Path" ? "learningpath" : "quickTips"
  const registerAemData = useSelector((state) => state.Aem.registerData);
  const userLanguage = localStorage.getItem("lng") ? localStorage.getItem("lng") : businessData?.attributes?.Language;
  const screenType = isDesktop ? "desktop" : isTablet ? "tablet" : isMobile ? "mobile" : "desktop";
  const resourseId = modifiedType === "quickTips" ? props?.data?.courseId : isInPersonEvent ? props?.data?.courseId?.split(":")?.[1] : props?.data?.id?.split(":")?.[1];
  const renditionType = modifiedType === "courses" ? "categoryCourses": modifiedType === "events" ? "categoryEvents" : modifiedType === "quickTips" ? "categoryquickTips": "categoryCourses"
  const [imageUrl, setImageUrl] = useState(null);
  const imgFormat = useSelector((state) => state?.Aem?.imgFormat) ?? 'avif';

  let courseTags = props.data.tags;
  
  if (registerAemData &&
    registerAemData.registerModule &&
    registerAemData.registerModule.topics &&
    courseTags != null) {
    courseTags = courseTags.filter(item => registerAemData.registerModule.topics.filter(topicItem => topicItem.label === item).length > 0);
  }

  let dateTime = "";
  if(props?.data?.duration?.dateTime) {
    dateTime = props?.data?.duration?.dateTime;
  } else if (props?.data?.duration) {
    dateTime = props?.data?.duration;
  } else {
    dateTime = props?.data?.dateAndTimeValue;
  }

 useEffect(() => {
  // Helper to test if a URL is valid and reachable within 2 seconds
  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      if (!url || url.trim() === "") return reject(new Error("Invalid URL"));
      const img = new Image();
      img.src = url;
      const timeout = setTimeout(() => {
        img.src = ""; // Stop the browser from continuing to load
        reject(new Error("Timeout"));
      }, 2000);
      
      img.onload = () => {
        clearTimeout(timeout);
        resolve(url);
      };
      img.onerror = () => {
        clearTimeout(timeout);
        reject(new Error("Image Load failed"));
      };
    });
  };

   const loadImage = async () => {
    
    setImageUrl('');

    try {
      // 1.Call method with "avif" parameter
      try {
       const avifUrl = await getImageToBeRendered(renditionType, screenType, modifiedType, userLanguage, resourseId, props?.data?.desktopImage, imgFormat,sectionKey);
       await preloadImage(avifUrl);
        setImageUrl(avifUrl);
        return; 
      } catch (e) {
        console.warn("AVIF failed, trying PNG...");
      }

      // 2. Call method without "avif" (defaults to PNG)
      // try {
      //   const pngUrl = getImageToBeRendered(renditionType, screenType, modifiedType, userLanguage, resourseId, props?.data?.desktopImage,null);
      //   await preloadImage(pngUrl);
      //   setImageUrl(pngUrl);
      //   return; 
      // } catch (e) {
      //   console.warn("PNG failed, trying Fallback Data...");
      // }

      // 3. LMS image as fallback
      const dataFallbackUrl = props?.data?.desktopImage || props?.data?.image || props?.data?.imageUrl ;
      if (dataFallbackUrl) {
        try {
          await preloadImage(dataFallbackUrl);
          setImageUrl(dataFallbackUrl);
          return;
        } catch (e) {
          console.warn("fallback image failed to load.");
        }
      }

      // setting ulr as empty string
      setImageUrl('');    

    } catch (error) {
     
      setImageUrl('');
    } finally {
      
    }
  };

  loadImage();
}, [screenType,userLanguage,imgFormat]);




  //Duration conversion for language
  const getTimeInLanguage = (time) => {
    time = time?.replace('minutes remaining', t('minutes remaining'));
    time = time?.replace('minutes', t('minutes'));
    // Remove ':00' from the time if it exists
    time = time?.replace(/:00/g, '');
    return time;
  }
  
  const getLpId=()=>{
    let urlsArr = [];    
    let urlVal = localStorage.getItem('url')?.startsWith('/es/') ? localStorage.getItem('url').slice(3,localStorage.getItem('url').length) : localStorage.getItem('url');
    urlsArr.push(urlVal);
    localStorage.removeItem('url')
    sessionStorage.setItem('learningProgramId',JSON.stringify(urlsArr));
  }

  return (
    <div className='calendar-card'>
    {isInPersonEvent ? 
      (
        data?.metroArea &&
      <ResourceTag text={data?.metroArea} />
      ) : (
        props?.data?.tag &&
      <ResourceTag text={t(props?.data?.tag)} /> )}
      <div
        className={`event-item${((isInPersonEvent && data?.metroArea) || props?.data?.tag || props?.isResourseTag) ? ' no-top-left-radius' : ''}`}
      >
        <div
          className={`${isInPersonEvent ? 'event-profile-ip pa-3X sm-pa-2X' : 'event-profile pa-3X sm-pa-2X'}${((isInPersonEvent && data?.metroArea) || props?.data?.tag || props?.isResourseTag) ? ' no-top-left-radius' : ''}`}
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          {props?.data?.saveIcon &&
            <span className='event-badge'>
              <ButtonIcon
                kind="lowContrast"
                size="small"
                surfaceType="media"
                renderIcon={(props) => <Icon name="bookmark" {...props} />}
              />
            </span>
          }
        </div>
        <div className='event-info pa-6X sm-pa-3X'>
                <div className={"label mb-3X sm-mb-2X  hidemobileonly"}>
            {isInPersonEvent ?
              (<Micro><div className="titles-label label sm-mb-2X" aria-label={inPersonEventCxData?.ipEventModuleTxts?.inpersonEvtTxt}>
                <b>{t(inPersonEventCxData?.ipEventModuleTxts?.inpersonEvtTxt)}</b>
              </div> </Micro>) : (
                <Micro>
                  {props?.isLearningPath ? ((  <div className="duration-text flex-align hidemobileonly">

                    <span className='calendar-icon mr-1X'>
                      {(props?.data.enrollmentStatus == "ENROLLED" || props?.data.enrollmentStatus == "WAITING" || props?.data.enrollmentStatus == "STARTED") && <Icon
                        name={props?.data?.additionalStatus?.tagIcon}
                        size="small"
                        color={props?.data?.additionalStatus?.color}
                      />}
                      {(props?.data.enrollmentStatus == "NOT_ENROLLED" || props?.data.format == "Event") && !props?.data?.isRecordedEvent && !isInPersonEvent && <Icon
                        name={t("calendar")}
                        size="small"
                        color='gray'
                      />}
                      {props?.data.format != "Event" && <Icon
                        name="timer"
                        size="small"
                        // color={props?.data?.duration?.color}
                        color='gray'
                      />}

                      {isInPersonEvent && <Icon
                        name="calendar"
                        size="small"
                        color="#716F6D"
                      />}
                    </span>

                    {isInPersonEvent ? (
                      <Micro
                        color="#716F6D" bold={true}>
                        {data?.cardDate}
                      </Micro>
                    ) : (<Micro
                      color={props?.data?.duration?.color || "#716F6D"} bold={true}>
                      {t(getTimeInLanguage(dateTime))}
                    </Micro>)}


                    {isInPersonEvent && props?.data?.isFinalDayEnrollment && <Micro
                      color={props?.data?.additionalStatus?.color}>
                      {inPersonEventCxData?.ipEventModuleTxts?.enrollLstDateMsg ?? props?.data?.additionalStatus?.tagName}
                    </Micro>}
                  </div>)) : (
                    <div className='course-label' aria-label={props?.data?.resourceType}>
                    {props?.data?.format === "Event" ? <b>{t("Virtual Event")}</b>:<b>{t(props?.data?.format)}</b>}
                    {props?.data?.type &&
                      <span className='dot-wrap'></span>}
                    {props?.data?.format && <span id="ellipsisText" className='eventType'>{t(props?.data?.type)}</span>}

                  </div> )}
                </Micro>
              )}
          </div>               
                {props?.data?.additionalStatus && !isInPersonEvent &&
                  <span className='additional-tag mr-1X'>
                    <div style={{'display':'flex','alignItems':'center'}}>
                    <span className='tag-icon mr-1X'>
                      <Icon
                        name={props?.data?.additionalStatus?.registeredIcon}
                        size="small"
                        color={props?.data?.additionalStatus?.color}
                      />
                    </span>
                    <Micro
                      color={props?.data?.additionalStatus?.color} bold={false}>
                      {t(props?.data?.additionalStatus?.tagName)}
                    </Micro>
                    </div>
                    {props.data?.duration?.extLink && (
                    <TextLink
                      type='inline'
                      size='small'
                      color={props?.data?.duration?.color}
                      onClick={e => alert('TextLink clicked')}>
                      <span className="ml-2X">{props?.data?.duration?.extLink?.text}</span>
                    </TextLink>)}
                  </span>
                }
              
              <span className='event-right'>
              {!isMobile && (props?.data?.tag && props?.data?.tag != '') &&
                <span className='event-tag ph-3X pv-2X'>
                  <Body
                    size="small"
                    color="#000000"
                    bold={true}>
                      {t(props?.data.tag)} 
                  </Body>
                </span>
              }
            </span>
          
         
            <div id="ellipsisText" className='event-text sm-mb-4X'>
              <Title
                size="small"
                color="#000000"
                bold={false}>
                {props?.data.title ? props?.data.title : props?.data.label}
              </Title>
            </div>
          
            <div className="durations mt-auto">
          <div className='textarea'>
            <div className="duration-text flex-align">
            {(isMobile || props?.isLearningPath !== true ) && <span className={`${props?.isLearningPath !== true ? "" : "showMobileOnly" } flex-align`}>
            <span className='calendar-icon mr-1X showMobileOnly'>
                    {(props?.data.enrollmentStatus == "ENROLLED" || props?.data.enrollmentStatus == "WAITING" || props?.data.enrollmentStatus == "STARTED") && <Icon
                      name={props?.data?.additionalStatus?.tagIcon}
                      size="small"
                      color={props?.data?.additionalStatus?.color}
                    />}
                    {(props?.data.enrollmentStatus == "NOT_ENROLLED" || props?.data.format == "Event") && !props?.data?.isRecordedEvent && !isInPersonEvent && <Icon
                      name={t("calendar")}
                      size="small"
                      color='gray'
                    />}
                    {props?.data.format != "Event" && <Icon
                      name="timer"
                      size="small"
                      // color={props?.data?.duration?.color}
                      color='gray'
                    />}

                    {isInPersonEvent && <Icon
                      name="calendar"
                      size="small"
                      color="#716F6D"
                    />}
                  </span>
                  
                  {isInPersonEvent ? (
                    <Micro
                    color="#716F6D" bold={true}>
                    {data?.cardDate}
                  </Micro>
                  ) : (<Micro
                    color={props?.data?.duration?.color || "#716F6D"} bold={true}>
                    {t(getTimeInLanguage(dateTime))}
                  </Micro>)}
                  {/* {props?.data?.additionalStatus && !isInPersonEvent &&
                  <span className='additional-tag mr-1X'>
                    <span className='tag-icon mr-1X'>
                      <Icon
                        name={props?.data?.additionalStatus?.tagIcon}
                        size="medium"
                        color={props?.data?.additionalStatus?.color}
                      />
                    </span>
                    </span>}
                    <Micro
                      color={props?.data?.additionalStatus?.color} bold={false}>
                      {t(props?.data?.additionalStatus?.tagName)}
                    </Micro> */}

                  {isInPersonEvent && props?.data?.isFinalDayEnrollment && <Micro
                    color={props?.data?.additionalStatus?.color}>
                    {inPersonEventCxData?.ipEventModuleTxts?.enrollLstDateMsg ?? props?.data?.additionalStatus?.tagName}
                  </Micro>}
                  </span>}
                  </div>
            <span className='right-arrow' 
            role='link'
            aria-label={`${props?.data.title ? props?.data.title : props?.data.label} ${t(props?.data?.format)}`}
             onClick={e => {
              window.scrollTo(0, 0);
              contentClick(
                props?.data?.title,
                window.location.host +  `/course-details/${props.data.id}`,
                courseTags?.filter(Boolean)?.sort()?.map((tag)=>t(tag))?.slice(0,4)?.join(', ')
              );
              getLpId();
              navigateUsingLanguage("/course-details/"+(props?.data?.id ? props?.data?.id : props?.data?.courseId))}} tabIndex={0}>
              <Icon
                name="right-arrow"
                size="medium"
                color="#000000"
              />
            </span>        
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalendarViewCardComponent;
